<template>
<div class="chapter">
<div class="inner_page">
<p class="calibre_" id="filepos3144"><span class="calibre4">N<span class="small">OTHING</span> I S<span class="small">EE</span><br class="calibre1"/>M<span class="small">EANS</span> A<span class="small">NYTHING</span></span></p><div class="calibre_1"> </div>
<p class="calibre_2"><span class="calibre6"><em class="italic"><em class="italic">Quantum Questions, Quantum Answers</em></em></span></p><div class="calibre_3"> </div>
<p class="calibre_2"><span class="calibre7"><img alt="image" class="calibre3" src="images/00002.jpg"/></span></p>
<p class="calibre_4"><span class="calibre6">D<span class="small">AVID</span> P<span class="small">ARRISH</span>, MD</span></p>
<p class="calibre_5"><span class="calibre7"><img alt="image" class="calibre3" src="images/00003.jpg"/></span></p>
<p class="calibre_6"><span class="calibre7">SENTIENT PUBLICATIONS</span></p> <div class="mbp_pagebreak" id="calibre_pb_1"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_001.vue?f6c04dda